import {btn, cards, comp, Component, fieldset, router, tbar} from "@intermesh/goui";
import {t} from "./util/Translate.js";

export class Welcome extends Component {
	constructor() {
		super("section");
		this.itemId = "welcome";
		this.id = "welcome";
		this.cls = "card";

		const p = fieldset({}, comp({
				tagName: "div",
			},
			comp({
				tagName: "h3",
				cls: "ifw-title",
				text: t("Welcome")
			}),
			comp({
				tagName: "h4",
				cls: "ifw-subtitle",
				text: t("Do you have an account")
			}),
			comp({
					cls: "hbox pad",
					style: {
							justifyContent: "center",
					}
				},
				btn({
					cls: "primary goui-bigbutton",
					html: `<h4>${t("Yes")}</h4><h5>${t("Login")}</h5>`,
					route: "login"
				})
				, btn({
					cls: "accent goui-bigbutton",
					html: `<h4>${t("No")}</h4><h5>${t("Register")}</h5>`,
					route: "register"
				})
			)
		));
		this.items.add(
			comp({}, cards({
					activeItem: 0
				}, comp(
					{}, p))
				, tbar({cls: "ifw-bbar"},
					btn({text: t("Back"), handler: () => router.goto("")}))
			));
	}

}